import App from './App.svelte';



window.randomTeachers = function (target, courseSearchUrl, count, title,subTitle,posts,layout,cardHeight,coulmnCount,textSize) {
	//console.log("Passing layout to Svelte:", layout);
	var app = new App({
		target: document.getElementById(target),
		props: {count:count, courseSearchUrl: courseSearchUrl,title:title,subTitle:subTitle,posts:posts,layout:layout,cardHeight:cardHeight,coulmnCount:coulmnCount,textSize:textSize}
	});
}